export default "__VITE_PUBLIC_ASSET__cde34226__"